var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-layout',{attrs:{"navbar-height":"0rem","local-styles":_vm.customStyles},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('div',{staticClass:"eb-container flex-grow-1 w-100 d-flex flex-column"},[_c('nuxt')],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }